/*
 * Copyright (c) Dito Technologies
 */

import React, {Dispatch} from "react";
import {Action, State} from "ui/feature/root/FormReducer";
import UploadWorkspaceFile from "ui/feature/root/upload/UploadWorkspaceFile";
import styles from "./UploadWorkspaceFileList.module.scss";

interface Props {
    state: State
    dispatch: Dispatch<Action>
}

const UploadWorkspaceFileList: React.FC<Props> = ({state, dispatch}) => {
    return (
        <div className={styles.fileListContainer}>
            {state.files.map((file) => <UploadWorkspaceFile
                key={file.name}
                state={state}
                dispatch={dispatch}
                file={file}/>)}
        </div>
    )
}

export default UploadWorkspaceFileList;
